"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDecimalField2 = void 0;
const decimal_field2_1 = require("../../../components/decimal-field/decimal-field2");
const form_field_1 = require("./form-field");
exports.FormDecimalField2 = form_field_1.formFieldFactory(decimal_field2_1.DecimalField2);
//# sourceMappingURL=form-decimal-field2.js.map